@if (invoice) {
    <div class="header-label">{{ 'Invoice #' + invoice?.invoiceNumber }}</div>
}
@if (invoice) {
    <div class="flex-fill d-flex flex-column">
        <div class="dx-card responsive-paddings">
            <div class="row">
                <div class="col-7">
                    @if (hasChanges()) {
                        <button (click)="save()" class="btn btn-success me-2">Save</button>
                    }
                    @if (hasChanges()) {
                        <button (click)="cancel()" class="btn btn-danger">Cancel</button>
                    }
                    @if (!hasChanges()) {
                        <button (click)="close()" class="btn btn-primary">Close</button>
                    }
                    @if (!hasChanges() && invoice?.statusId === 1) {
                        <button class="btn btn-danger ms-5 me-2" (click)="deleteInvoice()">Delete Invoice</button>
                    }
                    @if (!hasChanges() && invoice?.statusId !== 1) {
                        <button class="btn btn-danger ms-5 me-2" [disabled]="invoice?.statusId === 14" (click)="voidInvoice()">
                            Void Invoice
                        </button>
                    }
                    @if (!hasChanges()) {
                        <button (click)="printInvoice()" class="btn btn-primary ms-5 me-2">Print Invoice</button>
                    }
                    @if (!hasChanges() && !readOnly && invoice.statusId !== 5) {
                        <button (click)="sendForReview(invoice)" class="btn btn-primary">Send For Review</button>
                    }
                    @if (!hasChanges() && !readOnly && invoice.statusId === 5) {
                        <button (click)="changeStatusAndNext()" class="btn btn-primary me-2">Add to Queue & Next</button>
                    }
                    @if (!hasChanges() && !readOnly && invoice.statusId === 5) {
                        <button (click)="changeStatusAndNext(true)" class="btn btn-primary">Reject & Next</button>
                    }
                </div>
                <div class="col-5 d-flex align-items-center ms-auto">
                    <div class="d-flex ms-auto me-1 mt-2">
                        <div class="d-flex align-items-center me-5">
                            <label class="mt-2 me-2">Invoice Date</label>
                            <dx-date-box [(value)]="invoice.invoiceDate" [readOnly]="readOnly">
                                <dx-validator validationGroup="invoiceValidationGroup">
                                    <dxi-validator-validation-rule type="required" message="Required"> </dxi-validator-validation-rule>
                                </dx-validator>
                            </dx-date-box>
                        </div>
                        <div class="d-flex align-items-center">
                            <label class="me-2">Status</label>
                            <h4 class="me-2">
                                <strong
                                    [class.voided-invoice-color]="invoice.statusId === 14"
                                    [class.invoice-status-large-text]="invoice.statusId === 14"
                                    >{{ invoice.status?.name }}</strong
                                >
                            </h4>
                            @if (invoice.statusId === 4) {
                                <button class="btn btn-sm btn-danger ms-2" (click)="editInvoice()">Edit Invoice</button>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" class="p-2">
                @if (invoice) {
                    <dx-form [formData]="invoice" [colCount]="4" validationGroup="invoiceValidationGroup">
                        <dxi-form-item itemType="group" caption="Site Info">
                            @if (!rentalId && key === 'new') {
                                <dxi-form-item [label]="{ text: 'Customer' }">
                                    <div *dxTemplate>
                                        <dx-select-box
                                            [(value)]="invoice.customerId"
                                            [dataSource]="customersDS"
                                            valueExpr="id"
                                            displayExpr="displayName"
                                            [searchEnabled]="true"
                                            [showClearButton]="true"
                                            (onValueChanged)="onCustomerChanged($event)"
                                        >
                                            <dx-validator validationGroup="invoiceValidationGroup">
                                                <dxi-validator-validation-rule type="required" message="Required">
                                                </dxi-validator-validation-rule> </dx-validator
                                        ></dx-select-box>
                                    </div>
                                </dxi-form-item>
                            }
                            @if (!rentalId && key === 'new') {
                                <dxi-form-item [label]="{ text: 'Address' }">
                                    <div *dxTemplate>
                                        <dx-select-box
                                            [(value)]="invoice.serviceAddressId"
                                            [dataSource]="customerLocations"
                                            valueExpr="id"
                                            displayExpr="displayAddress"
                                            (onValueChanged)="onSiteLocationChanged($event)"
                                        >
                                            <dx-validator validationGroup="invoiceValidationGroup">
                                                <dxi-validator-validation-rule type="required" message="Required">
                                                </dxi-validator-validation-rule> </dx-validator
                                        ></dx-select-box>
                                    </div>
                                </dxi-form-item>
                            }
                            @if (invoice.serviceAddressId && key === 'new') {
                                <dxi-form-item [label]="{ text: 'Rental' }">
                                    <div *dxTemplate>
                                        <dx-select-box [(value)]="invoice.rentalId" [dataSource]="rentals" valueExpr="id" displayExpr="id">
                                            <dx-validator validationGroup="invoiceValidationGroup">
                                                <dxi-validator-validation-rule type="required" message="Required">
                                                </dxi-validator-validation-rule> </dx-validator
                                        ></dx-select-box>
                                    </div>
                                </dxi-form-item>
                            }
                            <dxi-form-item>
                                <div *dxTemplate>
                                    <h3 class="mt-0 mb-1">{{ invoice?.customer?.displayName }}</h3>
                                    <div>{{ invoice?.serviceAddress1 }}</div>
                                    <div>{{ invoice?.serviceAddress2 }}</div>
                                    <div>
                                        {{ invoice?.serviceCity ? invoice.serviceCity + ',' : '' }}
                                        {{ invoice?.serviceState }}
                                        {{ invoice?.serviceZip }}
                                        {{ invoice?.serviceCountry }}
                                    </div>
                                    @if (hasHaulingRates) {
                                        <div>Distance: {{ invoice?.rental?.serviceAddress?.distance }}</div>
                                    }
                                    <div>Range: {{ invoice?.rental?.serviceAddress?.range }}</div>
                                    <div class="mt-3">
                                        <strong>Rental Period: {{ rentalPeriod }}</strong>
                                    </div>
                                </div>
                            </dxi-form-item>
                        </dxi-form-item>
                        <dxi-form-item itemType="group" caption="Payment Info">
                            <dxi-form-item
                                dataField="paymentMethod"
                                [label]="{ text: 'Method' }"
                                editorType="dxSelectBox"
                                [editorOptions]="{ dataSource: paymentMethods, readOnly: readOnly, onValueChanged: paymentMethodChanged }"
                            >
                            </dxi-form-item>
                            <dxi-form-item itemType="group" [colCount]="3">
                                <dxi-form-item
                                    dataField="creditCardId"
                                    [label]="{ text: 'Credit Card' }"
                                    editorType="dxSelectBox"
                                    [editorOptions]="{
                                        items: creditCards,
                                        displayExpr: 'name',
                                        valueExpr: 'id',
                                        readOnly: readOnly,
                                        onValueChanged: creditCardChanged
                                    }"
                                    [visible]="invoice.paymentMethod === 'Credit-Debit'"
                                ></dxi-form-item>
                                <dxi-form-item
                                    dataField="creditCardPercentage"
                                    [label]="{ text: 'Percentage' }"
                                    editorType="dxNumberBox"
                                    [editorOptions]="{ readOnly: true }"
                                    [visible]="invoice.paymentMethod === 'Credit-Debit'"
                                ></dxi-form-item>
                                <dxi-form-item
                                    dataField="creditCardFee"
                                    [label]="{ text: 'Processing Fee' }"
                                    [editorOptions]="{ format: { type: 'currency', precision: 4 }, readOnly: true }"
                                    [visible]="invoice.paymentMethod === 'Credit-Debit'"
                                >
                                </dxi-form-item>
                            </dxi-form-item>
                            <dxi-form-item
                                dataField="terms"
                                [label]="{ text: 'Terms' }"
                                editorType="dxSelectBox"
                                [editorOptions]="{
                                    dataSource: terms,
                                    valueExpr: 'name',
                                    displayExpr: 'name',
                                    onSelectionChanged: onTermsChanged,
                                    readOnly: readOnly
                                }"
                            >
                            </dxi-form-item>
                        </dxi-form-item>
                        <dxi-form-item itemType="group" caption="Total">
                            <!-- <dxi-item
                      dataField="totalWithTaxMinusFee"
                      [label]="{ text: 'Subtotal' }"
                      [editorOptions]="{ format: { type: 'currency', precision: 2 }, readOnly: true }"
                      [visible]="invoice.paymentMethod === 'Credit-Debit'"
                      >
                    </dxi-item>
                    <dxi-item
                      dataField="creditCardFee"
                      [label]="{ text: 'Processing Fee' }"
                      [editorOptions]="{ format: { type: 'currency', precision: 4 }, readOnly: true }"
                      [visible]="invoice.paymentMethod === 'Credit-Debit'"
                      >
                    </dxi-item> -->
                            <dxi-form-item
                                dataField="totalWithTax"
                                [label]="{ text: 'Total' }"
                                [editorOptions]="{ format: { type: 'currency', precision: 2 }, readOnly: true }"
                            >
                            </dxi-form-item>
                            <dxi-form-item
                                dataField="unpaidBalance"
                                [editorOptions]="{ format: { type: 'currency', precision: 2 }, readOnly: true }"
                            >
                            </dxi-form-item>
                        </dxi-form-item>
                        <dxi-form-item itemType="group" caption="Great Plains Info">
                            <dxi-form-item dataField="quickBooksId" [label]="{ text: 'System' }" [editorOptions]="{ readOnly: true }">
                            </dxi-form-item>
                            <dxi-form-item
                                dataField="quickBooksLastExport"
                                [label]="{ text: 'Last Exported' }"
                                [editorOptions]="{ readOnly: true }"
                            >
                            </dxi-form-item>
                        </dxi-form-item>
                    </dx-form>
                }
            </div>
        </div>
        <div class="d-flex flex-fill flex-row dx-card responsive-paddings">
            <div class="d-flex col-sm-9">
                <dx-data-grid
                    #invoiceLineGrid
                    keyExpr="id"
                    [dataSource]="invoiceLines"
                    [showBorders]="true"
                    [showRowLines]="true"
                    [rowAlternationEnabled]="true"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                    (onRowDblClick)="rowDoubleClick($event)"
                >
                    <dxi-data-grid-column
                        dataField="lineNumber"
                        caption="No."
                        [visible]="true"
                        width="80"
                        [sortIndex]="1"
                        [sortOrder]="'asc'"
                    ></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="description" width="325"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="service" width="165"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="weight" width="100"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="quantity" width="100"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="rate" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-data-grid-column>
                    <dxi-data-grid-column
                        dataField="total"
                        [format]="{ type: 'currency', precision: 2 }"
                        width="100"
                    ></dxi-data-grid-column>
                    <dxi-data-grid-column
                        dataField="quickBooksProduct.quickBooksProductService"
                        caption="Account"
                        width="125"
                    ></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="jobId" width="100"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="note"></dxi-data-grid-column>
                    <dxo-data-grid-selection [mode]="'multiple'"></dxo-data-grid-selection>
                    <dxo-data-grid-state-storing
                        [enabled]="true"
                        type="localStorage"
                        storageKey="invoice-lines-grid"
                    ></dxo-data-grid-state-storing>
                    <div *dxTemplate="let data of 'toolbarButtons'">
                        <button
                            class="btn btn-sm btn-secondary me-1 mb-2"
                            (click)="move(invoiceLineGrid.instance.getSelectedRowsData()[0], 'up')"
                            [disabled]="readOnly || invoiceLineGrid.instance.getSelectedRowsData().length !== 1"
                        >
                            <i class="fa fa-long-arrow-up" aria-hidden="true"></i>
                        </button>
                        <button
                            class="btn btn-sm btn-secondary me-2 mb-2"
                            (click)="move(invoiceLineGrid.instance.getSelectedRowsData()[0], 'down')"
                            [disabled]="readOnly || invoiceLineGrid.instance.getSelectedRowsData().length !== 1"
                        >
                            <i class="fa fa-long-arrow-down" aria-hidden="true"></i>
                        </button>
                        <button class="btn btn-sm btn-success me-1 mb-2" (click)="addInvoiceLine(null, true)" [disabled]="readOnly">
                            Add Line
                        </button>
                        <button
                            class="btn btn-sm btn-danger me-4 mb-2"
                            (click)="removeInvoiceLine(invoiceLineGrid.instance.getSelectedRowsData())"
                            [disabled]="readOnly"
                        >
                            Remove
                        </button>
                        <button class="btn btn-sm btn-success me-2 mb-2" (click)="addCountyFee()" [disabled]="readOnly || !invoiceLines">
                            Add County Surcharge
                        </button>
                        <button class="btn btn-sm btn-success me-2 mb-2" (click)="addFuelCharge()" [disabled]="readOnly || !invoiceLines">
                            Add Fuel Charge
                        </button>
                    </div>
                </dx-data-grid>
            </div>
            <div class="d-flex col-sm-3">
                <dx-data-grid
                    #dumpsterFeesGrid
                    keyExpr="id"
                    [dataSource]="jobDumpsterFees"
                    [showBorders]="true"
                    [showRowLines]="true"
                    [rowAlternationEnabled]="true"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                >
                    <dxi-data-grid-column dataField="jobId" width="55"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="dumpsterFeeType.name" caption="Type" width="150"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="quantity" width="65"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="invoiceLines[0].id" caption="Invoice Line Id" width="100"></dxi-data-grid-column>
                    <dxi-data-grid-column dataField="note"></dxi-data-grid-column>
                    <dxo-data-grid-selection mode="single"></dxo-data-grid-selection>
                    <dxo-data-grid-state-storing
                        [enabled]="true"
                        type="localStorage"
                        storageKey="dumpster-fees-grid"
                    ></dxo-data-grid-state-storing>
                    <div *dxTemplate="let data of 'toolbarButtons'">
                        <button
                            class="btn btn-sm btn-success me-1 mb-2"
                            (click)="addDumpsterFeeLine(dumpsterFeesGrid.instance.getSelectedRowsData()[0])"
                            [disabled]="
                                readOnly ||
                                dumpsterFeesGrid.instance.getSelectedRowsData().length !== 1 ||
                                dumpsterFeesGrid.instance.getSelectedRowsData()[0].invoiceLines[0]
                            "
                        >
                            Add To Invoice
                        </button>
                        <button
                            class="btn btn-sm btn-primary me-1 mb-2"
                            (click)="editDumpsterFeeNote(dumpsterFeesGrid.instance.getSelectedRowsData()[0])"
                            [disabled]="readOnly || dumpsterFeesGrid.instance.getSelectedRowsData().length !== 1"
                        >
                            Edit Note
                        </button>
                        <!-- <button class="btn btn-sm btn-success me-1 mb-2" (click)="addInvoiceLine(null, true)" [disabled]="readOnly">
                  Add Line
                </button> -->
                        <!-- <button
                class="btn btn-sm btn-danger me-4 mb-2"
                (click)="removeInvoiceLine(dumpsterFeesGrid.instance.getSelectedRowsData()[0])"
                [disabled]="readOnly || dumpsterFeesGrid.instance.getSelectedRowsData().length !== 1"
                >
                Remove
              </button> -->
                    </div>
                </dx-data-grid>
            </div>
        </div>
        <div class="dx-card responsive-paddings">
            <dx-form [formData]="invoice" [colCount]="2">
                <dxi-form-item
                    dataField="note"
                    editorType="dxTextArea"
                    [label]="{ text: 'Invoice Notes' }"
                    [editorOptions]="{ height: 100, readOnly: readOnly }"
                >
                </dxi-form-item>
                <dxi-form-item
                    dataField="privateNote"
                    editorType="dxTextArea"
                    [label]="{ text: 'Private Notes' }"
                    [editorOptions]="{ height: 100, readOnly: readOnly }"
                >
                </dxi-form-item>
            </dx-form>
        </div>
    </div>
}
